import axios, { configurateToken } from "@helpers/axios/private.axios";
import { AUTH, USER } from "../../constants";
import { getWallets, updateWalletEvent } from "@actions/wallet/changeWallet";
import { syncSavedTimezone } from "@helpers/timezone";

export const completeGoogleAuth = (token) => async (dispatch) => {
  localStorage.setItem("authToken", token);
  configurateToken(token);

  const response = await axios.get("/users/me");
  const data = response?.data?.data || {};
  const user = data?.user || null;
  const isFirstLogin = Boolean(data?.is_first_login);

  if (!user) {
    throw new Error("Failed to load user after Google sign-in");
  }

  syncSavedTimezone(user);

  dispatch({
    type: AUTH.AUTH_RESPONSE,
    payload: {
      user,
      token,
      isDemoUser: false,
    },
  });

  dispatch({
    type: USER.USER_RESPONSE,
    payload: {
      user,
      isFirstLogin,
    },
  });

  await dispatch(getWallets());
  dispatch(updateWalletEvent());

  return {
    user,
    token,
    isFirstLogin,
  };
};